import privateListings from './ducks/privateListings.duck';

export default {
  privateListings,
};
